import React from 'react';

import { Banner, useT } from '@repo/common';

import { ReactComponent as IdeaIcon } from '@repo/common/assets/icons/20px/icon_20px_idea-outline.svg';

const SkillsBanner = ({ $isMobile }) => {
  const t = useT();
  return (
    <div className='min-w-[280px] tabletH:max-w-[344px] w-full flex flex-col items-start gap-2'>
      <Banner
        type='info'
        size='s'
        label={t(
          'Add skills to showcase your strengths!',
          '스킬을 추가해 강점을 보여주세요!'
        )}
        message={t(
          `• Focus on skills relevant to the job you want
• Include both role-related and practical skills
• Avoid adding too many similar skills
• Aim for 8–12 skills for best readability`,
          `• 원하는 직무와 관련된 스킬 위주로 작성해 주세요
• 직무 관련 스킬과 실무 스킬을 함께 담아 주세요
• 비슷한 스킬을 너무 많이 추가하지 않는 것이 좋아요
• 가독성을 위해 8–12개 정도가 적당해요`
        )}
        hideButton
        hideClose={!$isMobile}
        icon={<IdeaIcon />}
      />
    </div>
  );
};

export default SkillsBanner;
